import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';
import { api } from '../services/api/client.js';
import { emailVerificationWallEnabled } from '../lib/flags';
import { freePublishingState } from '../lib/freePublishing.js';
import VerifyEmailWall from '../screens/VerifyEmailWall.jsx';

// Preserve the opt-in email wall outside the server-granted Free cohort. Use
// the existing cached/deduplicated billing read, never a plan or source hint.
function UnverifiedEmailGate({ userId, children, fallback }) {
  const [access, setAccess] = useState(null);
  useEffect(() => {
    let cancelled = false;
    api.billing.getEntitlements().then(entitlements => {
      if (!cancelled) setAccess(Boolean(freePublishingState(entitlements)));
    }).catch(() => {
      if (!cancelled) setAccess(false);
    });
    return () => { cancelled = true; };
  }, [userId]);

  if (access == null) return fallback;
  return access ? children : <VerifyEmailWall />;
}

export default function RequireVerifiedEmail({ children, fallback = null }) {
  const { user } = useAuth();
  if (!emailVerificationWallEnabled() || user?.emailVerified !== false) return children;
  if (user?.id == null) return <VerifyEmailWall />;
  // A different identity mounts a fresh closed gate before any effects run.
  return <UnverifiedEmailGate key={user.id} userId={user.id} fallback={fallback}>{children}</UnverifiedEmailGate>;
}
